export default __webpack_public_path__ + "static/media/chairman.b9ec804b.jpg";